import $ from 'jquery';
import 'bootstrap';
import { uniq } from 'lodash';

import { cookieGetItem } from '../../cookie';
import { USER_INFO, CLASS_DOMAIN } from '../../constants';


// 7098,2023 CPA - 经济法 VIP私塾班
// 7100,2023 CPA - 税法 VIP私塾班
// 7102,2023 CPA - 战略 VIP私塾班
// 7104,2023 CPA - 会计 VIP私塾班
// 7106,2023 CPA - 审计 VIP私塾班
// 7108,2023 CPA - 财管 VIP私塾班

// 10728,2024 CPA - 财管  VIP定制班
// 10731,2024 CPA - 审计  VIP定制班
// 10734,2024 CPA - 经济法  VIP定制班
// 10737,2024 CPA - 税法  VIP定制班
// 11400,2024 CPA - 会计  VIP定制班
// 10743,2024 CPA - 战略  VIP定制班

export const init = () => {
  const coursePriceArr = [
    { id: 10798, price: 799 },
    { id: 10799, price: 799 },
    { id: 10800, price: 799 },
    { id: 10796, price: 799 },
    { id: 10795, price: 799 },
    { id: 10797, price: 799 },
  ];
  let goodsIds = [];
  let limitYear = 1;
  let Sum = '0.00';
  let currentSum = 0;
  let originalSum = 0;
  let oneYears = 0;
  let twoYears = 0;
  let threeYears = 0;
  let discount = 0;

  const checkboxGroup1 = $('input[name="inlineCheckbox1"]');
  const checkboxGroup2 = $('input[name="inlineCheckbox11"]');
  const checkboxGroup3 = $('input[name="inlineCheckbox111"]');

  const elInlineRadio1 = $('#inlineRadio1');
  const elInlineRadio11 = $('#inlineRadio11');
  const elInlineRadio111 = $('#inlineRadio111');
  const elInlineRadio2 = $('#inlineRadio2');
  const elInlineRadio22 = $('#inlineRadio22');
  const elInlineRadio222 = $('#inlineRadio222');
  const elInlineRadio3 = $('#inlineRadio3');
  const elInlineRadio33 = $('#inlineRadio33');
  const elInlineRadio333 = $('#inlineRadio333');
  const elCpaTwoYears = $('.cpa-twoYears');
  const elCpaThreeYears = $('.cpa-threeYears');
  const elCurrentOrSum = $('.currentOrSum');

  const calCheckbox = (v) => {
    let len = v.length;
    let sum = 0;
    goodsIds = [];
    for (let i = 0; i < len; i++) {
      sum += coursePriceArr[v[i]].price;
      goodsIds.push(coursePriceArr[v[i]].id);
    }
    if (len == 1) {
      Sum = 799;
      discount = 0;
      oneYears = 1;
      twoYears = 0;
      threeYears = 0;
      limitYear = 1;
    } else if (len == 2) {
      Sum = 1598;
      discount = 0;
      oneYears = 1;
      twoYears = 0;
      threeYears = 0;
      limitYear = 1;
    } else if (len == 3) {
      Sum = 2397;
      discount = 0;
      oneYears = 1;
      twoYears = 0;
      threeYears = 0;
      limitYear = 1;
    } else if (len == 4) {
      Sum = 3196;
      discount = 0;
      oneYears = 1;
      twoYears = 0;
      threeYears = 0;
      limitYear = 1;
    } else if (len == 5) {
      Sum = 3995;
      discount = 0;
      oneYears = 1;
      twoYears = 0;
      threeYears = 0;
      limitYear = 1;
    } else if (len == 6) {
      Sum = 4794;
      discount = 0;
      oneYears = 1;
      twoYears = 0;
      threeYears = 0;
      limitYear = 1;
    }
    originalSum = sum;
    goodsIds = uniq(goodsIds);
    if (oneYears != 0) {
      elInlineRadio1.prop('disabled', false);
      elInlineRadio11.prop('disabled', false);
      elInlineRadio111.prop('disabled', false);
      elInlineRadio1.prop('checked', true);
      elInlineRadio11.prop('checked', true);
      elInlineRadio111.prop('checked', true);
      elInlineRadio2.prop('disabled', true);
      elInlineRadio22.prop('disabled', true);
      elInlineRadio222.prop('disabled', true);
      elInlineRadio3.prop('disabled', true);
      elInlineRadio33.prop('disabled', true);
      elInlineRadio333.prop('disabled', true);
    } else if (twoYears != 0) {
      elInlineRadio1.prop('disabled', true);
      elInlineRadio11.prop('disabled', true);
      elInlineRadio111.prop('disabled', true);
      elInlineRadio2.prop('disabled', false);
      elInlineRadio22.prop('disabled', false);
      elInlineRadio222.prop('disabled', false);
      elInlineRadio2.prop('checked', true);
      elInlineRadio22.prop('checked', true);
      elInlineRadio222.prop('checked', true);
      elInlineRadio3.prop('disabled', true);
      elInlineRadio33.prop('disabled', true);
      elInlineRadio333.prop('disabled', true);
    } else if (threeYears != 0) {
      elInlineRadio1.prop('disabled', true);
      elInlineRadio11.prop('disabled', true);
      elInlineRadio111.prop('disabled', true);
      elInlineRadio2.prop('disabled', true);
      elInlineRadio22.prop('disabled', true);
      elInlineRadio222.prop('disabled', true);
      elInlineRadio3.prop('disabled', false);
      elInlineRadio33.prop('disabled', false);
      elInlineRadio333.prop('disabled', false);
      elInlineRadio3.prop('checked', true);
      elInlineRadio33.prop('checked', true);
      elInlineRadio333.prop('checked', true);
    } else {
      elInlineRadio1.prop('disabled', true);
      elInlineRadio11.prop('disabled', true);
      elInlineRadio111.prop('disabled', true);
      elInlineRadio2.prop('disabled', true);
      elInlineRadio22.prop('disabled', true);
      elInlineRadio222.prop('disabled', true);
      elInlineRadio3.prop('disabled', true);
      elInlineRadio33.prop('disabled', true);
      elInlineRadio333.prop('disabled', true);
      resetRadioButton();
    }
    calRadioButton(limitYear);
  };

  const bindCheckboxChange = (i, group) => {
    let courseType = [];
    if (group == 1) {
      if (checkboxGroup1.eq(i).is(':checked')) {
        checkboxGroup2.eq(i).prop('checked', true);
        checkboxGroup3.eq(i).prop('checked', true);
        // courseType.push()
      } else {
        checkboxGroup2.eq(i).prop('checked', false);
        checkboxGroup3.eq(i).prop('checked', false);
      }
    } else if (group == 2) {
      if (checkboxGroup2.eq(i).is(':checked')) {
        checkboxGroup1.eq(i).prop('checked', true);
        checkboxGroup3.eq(i).prop('checked', true);
      } else {
        checkboxGroup1.eq(i).prop('checked', false);
        checkboxGroup3.eq(i).prop('checked', false);
      }
    } else if (group == 3) {
      if (checkboxGroup3.eq(i).is(':checked')) {
        checkboxGroup2.eq(i).prop('checked', true);
        checkboxGroup1.eq(i).prop('checked', true);
      } else {
        checkboxGroup2.eq(i).prop('checked', false);
        checkboxGroup1.eq(i).prop('checked', false);
      }
    }

    checkboxGroup1.each((i, v) => {
      if ($(v).is(':checked')) {
        courseType.push(i);
      }
    });
    calCheckbox(courseType);
  };

  for (let i = 0, l = coursePriceArr.length; i < l; i++) {
    checkboxGroup1.eq(i).change(() => bindCheckboxChange(i, 1));
    checkboxGroup2.eq(i).change(() => bindCheckboxChange(i, 2));
    checkboxGroup3.eq(i).change(() => bindCheckboxChange(i, 3));
  }

  const calRadioButton = (v) => {
    limitYear = v;
    if (v == 2) {
      currentSum = Sum;
      elCurrentOrSum.html(`¥${currentSum}`);
      $('.cpa-originalSum').text(`¥${originalSum}`);
    } else if (v == 3) {
      currentSum = Sum;
      elCurrentOrSum.html(`¥${currentSum}`);
      $('.cpa-originalSum').text(`¥${originalSum}`);
    } else if (v == 1) {
      currentSum = Sum;
      elCurrentOrSum.html(`¥${Sum}`);
      if (discount != 0) {
        $('.cpa-originalSum').text(`¥${originalSum}`);
      } else {
        $('.cpa-originalSum').text('');
      }
    }
  };

  const resetRadioButton = () => {
    $('input[name="inlineRadioOptions1"]').eq(0).prop('checked', true);
    $('input[name="inlineRadioOptions2"]').eq(0).prop('checked', true);
    $('input[name="inlineRadioOptions3"]').eq(0).prop('checked', true);
  };

  const bindRadioChange = (i, group) => {
    if (group == 1) {
      if ($('input[name="inlineRadioOptions1"]').eq(i).is(':checked')) {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', true);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', true);
      } else {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', false);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', false);
      }
    } else if (group == 2) {
      if ($('input[name="inlineRadioOptions2"]').eq(i).is(':checked')) {
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', true);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', true);
      } else {
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', false);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', false);
      }
    } else if (group == 3) {
      if ($('input[name="inlineRadioOptions3"]').eq(i).is(':checked')) {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', true);
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', true);
      } else {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', false);
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', false);
      }
    }
    // calRadioButton(i + 1);
  };

  for (let i = 0, l = 3; i < l; i++) {
    $('input[name="inlineRadioOptions1"]')
      .eq(i)
      .change(() => bindRadioChange(i, 1));
    $('input[name="inlineRadioOptions2"]')
      .eq(i)
      .change(() => bindRadioChange(i, 2));
    $('input[name="inlineRadioOptions3"]')
      .eq(i)
      .change(() => bindRadioChange(i, 3));
  }

  $('.cpa-to-buy').on('click', (e) => {
    if (goodsIds.length) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = `${CLASS_DOMAIN}/order/${goodsIds
        .sort()
        .join('-')}?limitYear=${limitYear}`;
    }
  });

  window.addEventListener(
    'scroll',
    () => {
      if ($('html').scrollTop() > 300) {
        $('.is-open-section-mall').addClass('is-open');
      } else {
        $('.is-open-section-mall').removeClass('is-open');
      }
    },
    true
  );
};
